import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  GET_SELECTED_RECIPIENTS,
  UPDATE_ADMIN_EMAIL_TYPE,
} from "@/components/email/admin/ducks/Actions"
import { EMAIL_SENT_RESET, UPDATE_GROUP_EMAIL_TYPE } from "@/components/email/ducks/Actions"
import {
  defaultMergeFields,
  mailMergeTypes,
  validTypes,
} from "@/components/email/helpers/EmailFunctions"
import {
  CLOSE_MERGE_DRAWER,
  CONFIRMING_MERGE_SEND,
  DISABLE_MERGE_CONFIRMING,
  OPEN_MERGE_DRAWER,
  SAVE_MERGE_DEFAULTS,
} from "@/components/email/volunteer/ducks/Actions"

const defaultState = {
  mergeDrawerOpen: false,
  mergeConfirming: false,
  mailMergeQuery: "",
  template: "",
  scope: "",
  ...defaultMergeFields,
}

const volunteerEmailReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case SAVE_MERGE_DEFAULTS:
      return {
        ...oldState,
        ...action.params,
      }

    case UPDATE_GROUP_EMAIL_TYPE:
      return {
        ...defaultState,
        scope: action.params?.scope || "",
        template: action.params?.mailMergeQuery || "",
        mailMergeQuery: action.params?.mailMergeQuery || "",
      }
    case OPEN_MERGE_DRAWER:
      return {
        ...oldState,
        mergeDrawerOpen: true,
      }

    case GET_SELECTED_RECIPIENTS:
      return {
        ...oldState,
        template: null,
      }

    case CLOSE_MERGE_DRAWER:
      return {
        ...oldState,
        mergeDrawerOpen: false,
      }

    case CONFIRMING_MERGE_SEND:
      return {
        ...oldState,
        mergeConfirming: true,
      }

    case DISABLE_MERGE_CONFIRMING:
      return {
        ...oldState,
        mergeConfirming: false,
      }

    case UPDATE_ADMIN_EMAIL_TYPE:
      if (
        validTypes.includes(action.adminEmailType) ||
        mailMergeTypes.includes(action.adminEmailType)
      ) {
        return {
          ...defaultState,
          template: action.adminEmailType,
        }
      }
      return oldState

    case EMAIL_SENT_RESET:
      return defaultState

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default volunteerEmailReducer
